module.exports = {
    tag: 'crude',
    quality: 0,
    learning: -2,
    mana: -2
};